import React from 'react'
import values from 'mout/object/values'
import forOwn from 'mout/object/forOwn'
import sortByPropText from '../../../helpers/content/manageSets/sortByPropText'
import StudentDataRow from './ScoresByStudent/StudentDataRow'

export default function ScoresByStudentPage({studentScoring, subtests, headerText}) {
  const studentScoringArr = sortByPropText(values(studentScoring), 'lastName')
  let subjDict = {}
  forOwn(subtests, (subtest, key) => {
    subjDict[subtest.displayName] = key
  })

  function getSubtestScores (bySubtest) {
    return {
      e: bySubtest[subjDict.English].scale,
      m: bySubtest[subjDict.Math].scale,
      r: bySubtest[subjDict.Reading].scale,
      s: bySubtest[subjDict.Science].scale,
    }
  }

  return (
    <div className='new-page vertical-content scores-by-student'>
	    <section className='page-header'>
        <h3 className='page-title'>Scores by Student</h3>
        <h3 className='school-class-info'>{headerText}</h3>
      </section>

	    <table>
        <tr style={{borderBottom: '1px solid black'}}>
          <th className='name' style={{background: '#EEE'}}>Student Name</th>
          <th className='composite'>Composite
            <br />Score</th>
          <th className='english'>English Scale
            <br />Score</th>
          <th className='math'>Math Scale
            <br />Score</th>
          <th className='reading'>Reading Scale
            <br />Score</th>
          <th className='science'>Science Scale
            <br />Score</th>
        </tr>
        {
          studentScoringArr.map((student) => {
            const { userId, fullName, scoring } = student
            const { bySubtest } = scoring
            let scores = getSubtestScores(bySubtest)
            return (
              <StudentDataRow 
                key={userId}
                fullName={fullName}
                composite={scoring.byTest.scale}
                english={scores.e}
                math={scores.m}
                reading={scores.r}
                science={scores.s}
              />
            )
          })
        }
      </table>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/ScoresByStudentPage.js